<template>
<div class="parent-holder" v-if="finishedLoading">
    <div class="columns">
        

        <div class="switch_choice">
            <div class="checkbox_item citem_2" style="margin-left: 34px;">
                <label class="checkbox_wrap">
                    <span class="switch_text switch_text__left">Team</span>
                    <input type="checkbox" name="checkbox" class="checkbox_inp" v-model="individual" @input="switchView('individual')">
                    <span class="checkbox_mark"></span>
                    <span class="switch_text switch_text__left">Individual</span>
                </label>
            </div>

            <div class="checkbox_item citem_2">
                <label class="checkbox_wrap">
                    <span class="switch_text switch_text__left">Month</span>
                    <input type="checkbox" name="checkbox" class="checkbox_inp" v-model="intake" @input="switchView('intake')">
                    <span class="checkbox_mark"></span>
                    <span class="switch_text switch_text__left">Intake</span>
                </label>
            </div>
        </div>

        <div class="leaderboard_view">
            <b> Active date: {{ leaderboardDate.formatted }} </b>
            <b> Active intake: {{ intakeName }} </b>

            <div class="leaderboard_view_actions mb-2">
                <b-button v-if="leaderboardRelevantId.id !== leaderboardRelevantId.minId" size="is-small" icon-left="chevron-left" @click="fetchLeaderboard(true)">
                </b-button>

                <b-button v-if="isAdmin" size="is-small" type="is-danger" @click="deleteLeaderboard()">
                    Delete leaderboard
                </b-button>

                <b-button v-if="leaderboardRelevantId.id !== leaderboardRelevantId.maxId" size="is-small" icon-left="chevron-right" @click="fetchLeaderboard(false)">
                </b-button>
            </div>

            <div class="leadeview_list" v-for="(item, key) in generateSpecificLeaderBoard(generalLeaderboard[activeList])" :key="key">
                <div v-if="[1,2,3].includes(item.place)" :class="`winners_top winners_top_${item.place}`">
                    <b-image v-if="item.place === 1" class="leaderboard_crown" :src="require(`@/assets/media/leaderboard/crown.png`)" alt="No 1 crown"></b-image>
                    <span class="winner_image_holder" v-if="item.image_url">
                        <b-image rounded v-if="[3,4].includes(activeLeaderboard)" class="winner_image" :src="require(`@/assets/media/leaderboard/1/${item.image_url}.png`)" alt="Your team icon"></b-image>
                        <b-image rounded v-else class="winner_image" :src="item.image_url" alt=""></b-image>
                    </span>
                    <p class="winners_top_place">
                        {{ item.place }}
                    </p>
                    <p class="winners_top_username" :title="item.username">
                        {{ item.username }}
                    </p>
                </div>

                <div :class="`winners winners_no_${item.place}`">
                    <span class="winners_place">
                        {{ item.place }}
                    </span>
                    <span v-if="item.image_url" class="winners_profile">
                        <b-image v-if="[3,4].includes(activeLeaderboard)" rounded class="leaderboard_image" :src="require(`@/assets/media/leaderboard/1/${item.image_url}.png`)" alt="Your team icon"></b-image>
                        <b-image v-else rounded class="leaderboard_image" :src="item.image_url" alt=""></b-image>
                    </span>
                    <span class="winners_username" :title="item.username">
                        {{ item.username }}
                    </span>
                    <span class="winners_count">
                        {{ item.count }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import UtilService from '../services/util';
import LeaderboardService from "../services/leaderboard.service";
import {
    intakes
} from '../models/static'
import moment from 'moment';

export default {
    name: "leaderboard",
    components: {
    },
    data() {
        return {
            finishedLoading: true,
            intakeName: null,
            availableIntakes: [],
            individual: true,
            intake: true,
            leaderboardDate: {
                date: null,
                formatted: null
            },
            generalLeaderboard: {
                individual: [],
                team: []
            },
            leaderboardRelevantId: {
                id: null
            }
        };
    },
    mounted() {
        this.availableIntakes = intakes
        this.fetchLeaderboard(true)
    },
    computed: {
        isAdmin() {
            return UtilService.isAdmin()
        },

        activeList() {
            return this.individual ? 'individual' : 'team'
        },

        activeLeaderboard() {
            if (this.individual && this.intake) {
                return 1
            } else if (this.individual && !this.intake) {
                return 2
            } else if (!this.individual && !this.intake) {
                return 3
            } else if (!this.individual && this.intake) {
                return 4
            }

            return null
        }
    },

    methods: {
        fetchLeaderboard(olderLeaderboard) {
            LeaderboardService.getLeaderboard({
                id: this.leaderboardRelevantId.id,
                olderLeaderboard
            }).then((response) => {
                const winners = response.data && response.data.winners ? JSON.parse(response.data.winners) : null
                this.leaderboardRelevantId = {
                    id: response.data.id,
                    maxId: response.data.maxId,
                    minId: response.data.minId
                };

                this.finishedLoading = true

                if (winners) {
                    this.generalLeaderboard = {
                        individual: [],
                        team: []
                    }

                    this.leaderboardDate = {
                        date: response.data.createdAt,
                        formatted: moment(response.data.createdAt).format('LLL')
                    }
                    this.intakeName = winners.intake

                    this.generalLeaderboard.team = winners.teamResp.map(winner => {

                        this.generalLeaderboard.individual.push(winner.users)

                        return {
                            intakeCount: winner.intakeCountTeam,
                            monthCount: winner.monthCountTeam,
                            username: winner.teamName,
                            profileImagePlaceIntake: null,
                            profileImagePlaceMonth: null
                        }
                    })

                    this.generalLeaderboard.individual = this.generalLeaderboard.individual.flat(1).filter(
                        (value, index, self) =>
                        self.findIndex((obj) =>
                            JSON.stringify(obj) === JSON.stringify(value)) ===
                        index
                    );

                    this.generalLeaderboard = this.assignRanks(this.generalLeaderboard)
                }
            })
        },

        

        deleteLeaderboard() {
            LeaderboardService.removeLeaderboard(this.leaderboardRelevantId.id).then(() => {
                this.fetchLeaderboard()
            })
        },

        switchView(type) {
            this[type] = !this[type]
        },

        generateSpecificLeaderBoard(data) {
            const activeLeaderboard = this.activeLeaderboard
            switch (activeLeaderboard) {
                case 1:
                case 4:
                    return data.map(entry => {
                        return {
                            place: entry.intakePlace,
                            count: entry.intakeCount,
                            username: activeLeaderboard === 1 ? UtilService.visualUsername(entry.username) : entry.username,
                            image_url: activeLeaderboard === 4 ? entry.profileImagePlaceIntake : entry.profileImage ? entry.profileImage : `https://randomuser.me/api/portraits/lego/${Math.floor(Math.random() * 6) + 1}.jpg`,
                        }
                    }).sort((a, b) => b.count - a.count);

                case 2:
                case 3:
                    return data.map(entry => {
                        return {
                            place: entry.monthPlace,
                            count: entry.monthCount,
                            username: activeLeaderboard === 2 ? UtilService.visualUsername(entry.username) : entry.username,
                            image_url: activeLeaderboard === 3 ? entry.profileImagePlaceMonth : entry.profileImage ? entry.profileImage : `https://randomuser.me/api/portraits/lego/${Math.floor(Math.random() * 6) + 1}.jpg`,
                        }
                    }).sort((a, b) => b.count - a.count);

                default:
                    return data
            }
        },

        calculatePercentileRank(sortedArray, value) {
            const rank = sortedArray.findIndex(item => item === value) + 1;
            return (rank / sortedArray.length) * 100;
        },

        assignProfileImagePlace(percentile) {
            if (percentile <= 30) {
                return 4;
            } else if (percentile <= 40) {
                return 5;
            } else if (percentile <= 50) {
                return 6;
            } else if (percentile <= 60) {
                return 7;
            } else if (percentile <= 70) {
                return 8;
            } else if (percentile <= 80) {
                return 9;
            } else {
                return 10;
            }
        },
        assignRanks(data) {
            function addPlaces(arr, isTeam = false, context) {
                // Sort by intakeCount and monthCount
                const sortedByIntake = [...arr].sort((a, b) => b.intakeCount - a.intakeCount);
                const sortedByMonth = [...arr].sort((a, b) => b.monthCount - a.monthCount);

                // Assign intakePlace
                sortedByIntake.forEach((item, index) => {
                    item.intakePlace = index + 1;
                });

                // Assign monthPlace
                sortedByMonth.forEach((item, index) => {
                    item.monthPlace = index + 1;
                });

                if (isTeam) {
                    // Get array of intakeCounts and monthCounts for percentile calculation
                    const intakeCounts = sortedByIntake.map(team => team.intakeCount);
                    const monthCounts = sortedByMonth.map(team => team.monthCount);

                    // Assign profileImagePlaceIntake and profileImagePlaceMonth
                    sortedByIntake.forEach((team, index) => {
                        if (index < 3) {
                            team.profileImagePlaceIntake = index + 1;
                        } else {
                            const percentile = context.calculatePercentileRank(intakeCounts, team.intakeCount);
                            team.profileImagePlaceIntake = context.assignProfileImagePlace(percentile);
                        }
                    });

                    sortedByMonth.forEach((team, index) => {
                        if (index < 3) {
                            team.profileImagePlaceMonth = index + 1;
                        } else {
                            const percentile = context.calculatePercentileRank(monthCounts, team.monthCount);
                            team.profileImagePlaceMonth = context.assignProfileImagePlace(percentile);
                        }
                    });
                }

                return arr;
            }

            // Process individuals
            data.individual = addPlaces(data.individual, false, this);

            // Process teams
            data.team = addPlaces(data.team, true, this);

            return data
        }
    }

};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');

.switch_choice {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    flex: 100%;
}

.parent-holder {
    font-family: "Montserrat", sans-serif;
    font-optical-sizing: auto;
    font-weight: 500;
    font-style: normal;
}

span.switch_text {
    margin: 0 5px;
    color: #7a7a7a;
}

.checkbox_item .checkbox_wrap {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0 auto 50px;
}

.checkbox_item:last-child .checkbox_wrap {
    margin-bottom: 0;
}

.checkbox_item .checkbox_wrap .checkbox_inp {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
}

.checkbox_item .checkbox_wrap .checkbox_mark {
    display: inline-block;
    position: relative;
    border-radius: 25px;
}

.checkbox_item .checkbox_wrap .checkbox_mark:before,
.checkbox_item .checkbox_wrap .checkbox_mark:after {
    content: "";
    position: absolute;
    transition: all 0.5s ease;
}

/* flat styles */
.checkbox_item.citem_2 .checkbox_wrap .checkbox_mark {
    border: 5px solid #ffc451;
    min-width: 100px;
    height: 50px;
    padding: 2px;
}

.checkbox_item.citem_2 .checkbox_wrap .checkbox_mark:before {
    top: 2px;
    left: 2px;
    width: 44px;
    height: 36px;
    background: #ffc451;
    border-radius: 25px;
}

.checkbox_item.citem_2 .checkbox_wrap .checkbox_inp:checked~.checkbox_mark {
    border-color: #312244;
}

.checkbox_item.citem_2 .checkbox_wrap .checkbox_inp:checked~.checkbox_mark:before {
    left: 44px;
    background: #312244;
}

.leaderboard_view {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 100%;
    align-items: center;
    padding-top: 300px;
}

.winners_top {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
}

.winners_top_1 {
    top: 60px;
}

.winners_top_2 {
    margin-left: -170px;
}

.winners_top_3 {
    margin-left: 170px;
}

.winners_top_place {
    position: absolute;
    bottom: 21px;
    background: gold;
    padding: 12px;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 50%;
    transform: translateX(-50%);
    font-size: 18px;
    font-weight: 900;
    color: white;
    border: 5px solid white;
}

.leaderboard_crown {
    width: 80px;
    min-width: 80px;
    position: absolute;
    top: -40px;
    z-index: 2;
    margin-left: 50px;
}

.winner_image {
    max-width: 130px;
    max-height: 130px;
    border-radius: 50%;
    border: 8px solid transparent;
}

.winner_image_holder {
    background-color: red;
    border-radius: 50%;
}

.winners_top_1 .winner_image {
    border: 8px solid gold;
    max-width: 180px;
    min-width: 180px;
    max-height: 180px;
}

.winners_top_2 .winner_image {
    border: 8px solid silver;
}

.winners_top_2 .winners_top_place {
    background: silver;
}

.winners_top_3 .winner_image {
    border: 8px solid #FF8228;
}

.winners_top_3 .winners_top_place {
    background: #FF8228;
}

.winners_top_username {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 130px;
    margin-top: 10px;
    text-align: center
}

.winners_top_1 .winners_top_username {
    width: 180px;
}

.leadeview_list .winners {
    display: flex;
    background: #312244;
    color: white;
    padding: 12px 16px;
    border-radius: 12px;
    margin-bottom: 12px;
    width: 470px;
    justify-content: space-around;
    align-items: center;
}

.leadeview_list .winners_no_1 {
    background-color: gold;
    color: #312244;
}

.leadeview_list .winners_no_2 {
    background-color: silver;
    color: #312244;
}

.leadeview_list .winners_no_3 {
    background-color: #FF8228;
    color: #312244;
}

.leadeview_list .winners .winners_username {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 220px;
}

.winners .winners_profile .leaderboard_image {
    width: 30px;
    height: 30px;
}
</style>
